export default __webpack_public_path__ + "static/media/project.9cfa8a46.png";